module.exports = __webpack_public_path__ + "img/price-button.1c0d4d98.png";